// connections-page S-001 / D-23 : `/offices/:o/settings/data-sources` moved to
// `/offices/:o/connections`. The old path stays reachable (Composio return
// links already handed out, bookmarks, mission deep links) and redirects,
// carrying ONLY `data_source`, `tab` and `thread` — the return toast reads
// `data_source`, a mission panel reads `tab`/`thread`. Anything else in the
// query string is dropped (no open pass-through).
import { redirect } from 'react-router';

export const CONNECTIONS_REDIRECT_PARAMS = ['data_source', 'tab', 'thread'];

/** Pure : the target path for a legacy settings/data-sources URL. */
export function connectionsRedirectTarget(officeId, search) {
  const from = new URLSearchParams(search);
  const keep = new URLSearchParams();
  CONNECTIONS_REDIRECT_PARAMS.forEach((key) => {
    const v = from.get(key);
    if (v !== null) keep.set(key, v);
  });
  const qs = keep.toString();
  return `/offices/${encodeURIComponent(officeId)}/connections${qs ? `?${qs}` : ''}`;
}

/** react-router data-mode loader for the legacy path. */
export function connectionsRedirectLoader({ params, request }) {
  return redirect(connectionsRedirectTarget(params.officeId, new URL(request.url).search));
}
